import { type ISmartCallFlowStep } from 'entities/SmartCall/api/types'

export const getSmartActionNextIdsFromStep = (step: ISmartCallFlowStep): string[] => {
  if (
    step.id === 'callingFlow' &&
    step.args?.next_on_answered !== undefined &&
    step.args?.next_on_no_answer !== undefined
  ) {
    return [step.args.next_on_answered, step.args.next_on_no_answer]
  }
  if (step.id === 'ivrPhoneTree') {
    return step.args?.menu_options?.map((item) => item.stepId)
  }

  if (!step.next) {
    return []
  }

  return [step.next]
}
